import { api } from '../../DefaultService';
import {
  ISurgardCreateProps,
  ISurgardProps,
  ISurgardUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/surgard';

export const createSurgardIntegrationAsync = async (
  data: ISurgardCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSurgardIntegrationByIdAsync = async (
  id: number,
): Promise<ISurgardProps> => {
  return await api
    .get<ISurgardProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSurgardIntegrationAsync = async (): Promise<
  ISurgardProps[]
> => {
  return await api
    .get<ISurgardProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSurgardIntegrationAsync = async ({
  id,
  data,
}: ISurgardUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSurgardIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
